const ja = {
  general: {
    position: '職位',
    updateSuccess: '更新に成功しました！',
    editProfileImg: '個人写真',
    editCoverImg: '表紙写真',
    register: '登録',
    login: 'ログイン',
    date: '日付',
    export: 'エクスポート',
    or: '又は',
    end: '終了',
    confirmEmail: '電子メールの確認',
    password: 'パスワード',
    forgetPassword: 'パスワードを忘れました',
    changePassword: 'パスワードの変更',
    confirmPassword: 'パスワードの確認',
    knownAs: 'ニックネーム',
    oldPassword: '旧パスワード',
    newPassword: '新パスワード',
    minLength: '少なくとも{n}文字以上',
    unmatched: '{col}一致しません',
    chooseAnotherAccount: '他のアカウントでログインする',
    confirmNewPassword: '新パスワードの確認',
    required: '入力必須項目',
    country: '国家',
    new: '新',
    username: 'アカウント',
    category: 'カテゴリー'
  },
  editPhoto: '写真を編集する',
  deletePhoto: '写真を削除する',
  changePhoto: '写真を変更する',
  savePhoto: '写真を保存する',
  livetour: 'ブース',
  country: {
    JP: '日本',
    KR: '韓国',
    HK: '香港・マカオ',
    SG: 'シンガポール',
    MY: 'マレーシア',
    TH: 'タイ',
    VN: 'ベトナム',
    ID: 'インドネシア',
    PH: 'フィリピン',
    EU: 'ヨーロッパ',
    NA: '北米',
    NZ: 'ニュージーランド・オーストラリア',
    TW: '台湾'
  },
  vrlounge: {
    ticketNotOnboardHint: '実際の展示会のチケットの検査を受けてからオンラインバーチャル展にお進みください',
    cannotChangeAfterSubmit: '送信後は変更できません',
    willReceiveEmail: 'お客様はWEA2021オンライン展示プラットフォームシステム業者iStagingが送信した、パスワード再設定を含むemailをお受け取りになります。',
    hintLogin: 'すでにチケットナンバーを登録してある場合、「ログイン」をクリックし電子メールにてログインしてください。',
    lounge: '交流センター',
    networking: '名刺フォルダ',
    profile: 'パーソナルファイル',
    peopleOnline: 'オンラインユーザー',
    totalVisitors: '全ての訪問客',
    connect: '連絡',
    waitConfirmed: '確認待ち',
    isConfirmed: '確認済み',
    confirm: '確認',
    reject: '拒絶',
    confirmReject: '拒否しますか？',
    hintReject: 'この動作は復元できません',
    thinkTwice: 'よく考えさせて',
    rejectInvitation: '招待を拒否する',
    connectSuccess: '接続に成功しました',
    block: 'ブロック',
    visitor: '訪問客',
    exhibitor: '出展業者',
    invitationTitle: 'パーソナライズされた招待メッセージ',
    invitationPlaceholder: 'こんにちは！ あなたとつながることを願っています！ （最大1000文字）',
    noTicketRecord: 'このチケット番号はありません。チケット番号をお買い求めください。',
    invalidTicket: '無効なチケット番号です。',
    enterTicket: 'チケット番号を入力してください',
    sent: '送信したもの',
    received: '受信したもの',
    connected: 'リンクしたもの',
    agreeToContinue: '条項と条件にご同意いただいたうえで継続できます。',
    ticketUsed: 'チケットはすでに使用されています。',
    passwordRule: 'パスワードは必ず8文字で、少なくともアルファベットと数字を1つずつ含まなければなりません。',
    cardExchange: 'ビジターがあなたと名刺を交換したがっています。交換を受け入れるか拒否するかご確認ください。',
    loginToAccount: 'あなたのアカウントにログインします',
    keepLogin: 'ログイン状態を保持します',
    cantLogin: 'ログインできませんか。クリック',
    here: 'ここを',
    allRole: 'すべての役割',
    sortNameAtoZ: '名前（A→Z）',
    sortNameZtoA: '名前（Z→A）',
    onlineNewToOld: 'ゼロ登入時間（新到舊）',
    onlineOldToNew: 'ゼロ登入時間（舊到新）',
    exhibitorFirst: '出展者が先に来る',
    visitorFirst: '訪問者が先に来る',
    inviteTimeNewToOld: '招待時間（最新）',
    inviteTimeOldToNew: '招待時間（最も早い）',
    basicInfo: '基本情報',
    contact: '連絡',
    state: '状態',
    sentRequest: 'リクエストを送信',
    haveNotConfirmed: 'まだ確認していません',
    message: 'メッセージ',
    sendMessageTo: 'メッセージ'
  },
  sort: '選別',
  filter: 'フィルター',
  test: 'テスト',
  apply: '踏襲',
  all: '全て',
  livingroom: 'リビングルーム',
  diningroom: 'ダイニングルーム',
  kitchen: 'キッチン',
  bedroom: '寝室',
  study: '書斎',
  bathroom: 'バスルーム',
  toilet: 'トイレ',
  garden: '公共施設',
  garage: '車庫/停車位置',
  outdoors: '建物の外観',
  others: 'その他',
  vrTooltip: 'VRモードはモバイルでの使用に限ります',
  vrInstructions: '<strong>モバイル</strong>を<strong>VRゴーグル内</strong>に置いてください。',
  send: '送信',
  scanQrCode: 'QRcodeをスキャンすれば、すぐにあなたのモバイルでバーチャルリアリティ(VR)を体験できます。',
  logOut: 'ログアウト',
  postAsAnonymous: 'ゲストとしてメッセージを残す。',
  loginGoogle: 'Google+アカウントでログイン',
  loginFacebook: 'Facebookアカウントでログイン',
  postComment: 'メッセージ',
  selectAction: '選んでください',
  noBuilding: '申し訳ありません、この物件は存在しません。',
  browserNoSupport: '<h3>申し訳ありません。お客様のブラウザはサポートしていません。</h3><p><a href="https://www.google.com/chrome/browser/desktop">Chrome</a>、<a href="https://www.microsoft.com/en-us/download/internet-explorer-11-for-windows-7-details.aspx">IE11</a>又は<a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>などの最新バージョンのブラウザをダウンロードしインストールしてください。</p>',
  webGlNoSupport: '<h3>申し訳ありません。お客様のブラウザ又はデバイスはWebGLをサポートしていません。この<a href="https://www.istaging.com/webGLdetect/webGL.html" target="_blank">ページ</a>にアクセスしてください</h3>。',
  urlNoSupportIFrameError: 'このリンクはすでに失効したか当該ページは外部リンクの埋め込みを受け付けていません。',
  noPanoramas: '残念！このパノラマは存在しません。',
  buildingNotFound: '<h3>残念！お客様が選択したページは存在しません。</h3><p>リンク先のパノラマ画像はすでに削除された可能性があります。</p><a href="https://www.istaging.com/zh-tw/livetour-gallery">他のLiveTourにお進みください。</a>',
  weaBuildingNotFound: '<h3>素敵なWEA2021オンライン展示会は2021年3月10日10時に登場します。</h3>',
  buildingNotInPropertyRedirect: '<h3>残念！このLiveTourはすでに削除されました。</h3><p>まもなくこの物件の最初の項目に案内します……</p>',
  information: '紹介',
  panoSelect: 'パノラマ画像',
  floorplan: '平面図',
  qrCode: 'QR code',
  music: '音楽',
  gyro: 'Gyro',
  vrmode: 'VR モード',
  fullscreen: 'フルスクリーン',
  like: 'いいね',
  comment: 'メッセージ',
  propertyInfo: 'プロジェクトの紹介',
  buildingInfo: 'シーンの紹介',
  buyNow: '今すぐお買い上げ',
  viewAtHome: 'ARを見る',
  learnMore: 'もっと詳しく',
  contactSupplier: 'サプライヤーに連絡',
  memo: '注記',
  location: '場所',
  promotionText: 'VRリアリティ内見にアップグレードはたった149$から>',
  promotionLinkText: '今すぐ始める',
  close: '閉じる',
  addComment: 'メッセージの追加',
  share: 'シェア',
  leaveInfoContinue: 'お客様の情報を残しLive Tourをご覧ください',
  company: '会社',
  companyName: '会社名',
  name: '氏名',
  firstName: '名',
  lastName: '姓',
  email: '電子メール',
  phone: '電話',
  occupation: '職業',
  emailFormatInvalid: 'emailフォーマットが正しくありません',
  duplicateEmail: 'メールが重複している',
  privacyPolicy: 'プライバシーポリシー',
  userTerms: 'ユーザー規約',
  visitorLogin: 'すでにアカウントをお持ちですか',
  visitorAgreement1: '当社はお客様のデータプライバシーを非常に重視しています。チェックされますとお客様は{company}の{termsTag}と{privacyTag}にご同意されたことになり、同時に関連する管理機能を提供いたします。',
  visitorAgreement2: 'チェックされますとお客様は当社が{company}電話、電子メールまたはメッセージで関連製品とサービス情報をお送りすることを承認されたことを表します。お客様は{email}を通じて当社にこの承認を取り消すよう連絡できます。',
  visitorAgreement: '私は<a href="{termsUrl}" target="_blank">サービス利用規約</a>と<a href="{privacyUrl}" target="_blank">アカウントプライバシーポリシー</a>に同意します。',
  visitorLeaveDataReason: '以下の情報をご入力ください。入力されたメールアドレスに専用の認証リンクが送信されますので、クリックしていただくことでLineTourをご覧いただけるようになります。',
  visitorAgreePolicy: '私はLiveTourの物件所有者がEmail又は電話で私に連絡することに同意します。',
  visitorEnterAccessKey: 'Emailでお受け取りになった検証コードを入力してください。まだ受け取っていない場合、ゴミ箱に入っていないかどうか検査してください。',
  accessCode: '検証コード',
  accessCodeError: '検証コードエラーです',
  receiveEmailVerification: 'お客様のEmailで検証コードを受け取ってください。',
  verify: '検証',
  back: '戻る',
  welcomeToLiveTour: '<strong>LiveTour</strong>へようこそ。バーチャル体験を行います',
  resend: '再送',
  invalidAccessCode: '無効な検証コードです',
  resendCodeError: '検証コードの送信に失敗しました',
  website: 'ウェブサイト',
  cardMore: '更に多くのコンテンツ',
  clickNavigate: 'クリックして次へ',
  showMore: 'もっと見る',
  searchTag: 'ラベルの検索',
  somethingWrong: '<h3>システムに不明な問題が発生しました。</h3><a href="https://www.istaging.com/zh-tw/contact">問題を報告します。</a>',
  GuidedTour: 'オンライン視聴',
  ClientWelcome: 'ようこそ',
  ClientFormHint: '「電話をかける」をクリックすると、お客様は<a href="https://www.istaging.com/en/terms" target="_blank" class="link-yellow">サービス利用規約</a>、<a class="link-yellow" href="https://www.istaging.com/en/privacy" target="_blank">プライバシーポリシー</a> に同意し、専門スタッフが電話でお客様に連絡することに同意したことを表します。',
  ClientFormWelcomeText: '以下の情報をご入力いただき、電話をかけるを押してください。<br>専門スタッフが<mark class="mark-yellow">オンライン視聴にご案内します</mark>。<br>お客様はイヤマイクロフォンをお付けになり、<br>良好なネットワーク環境の下で行われるよう提案します。',
  ClientWelcomeNamePhoneHint: '氏名、電話番号を入力してください',
  ClientWelcomeNameHint: '氏名を入力してください',
  ClientWelcomePhoneHint: '電話番号又はフォーマットが正しくありません',
  ClientWelcomeLanguage: '言語',
  ClientWelcomeLanguageDesc: 'オンライン視聴で使用する言語を選択してください。',
  ClientWelcomeLanguageHint: '言語を選択してください',
  FieldRequired: '*入力必須',
  ClientFormCallNow: '電話をかける',
  None: '一時的にありません',
  Agent: '専門スタッフ',
  RememberMe: '私を覚えてください',
  TheFieldIsRequired: 'この欄は必ずご入力ください',
  IncorrectFormat: 'フォーマットエラーです',
  YouMustAgreeLicense: '以上の規約にご同意いただく必要があります',
  Submit: '送信',
  BuildingNonPublicInfo: 'この物件は非公開です',
  WebRTCNotSupportTitle: 'ブラウザをサポートしていません',
  WebRTCNotSupportDesc: 'お客様が現在ご使用のブラウザはこのサービスをサポートしていません。ボタンを押してウェブアドレスをコピーしChrome、Safari 又は Firefoxで開くことができます。',
  WebRTCNotSupportDesciOS: 'お客様が現在ご使用のブラウザはこのサービスをサポートしていません。ボタンを押してウェブアドレスをコピーしSafariで開くことができます。',
  WebRTCNotSupportDescAndroid: 'お客様が現在ご使用のブラウザはこのサービスをサポートしていません。ボタンを押してウェブアドレスをコピーしChrome又は Firefoxで開くことができます。',
  WebRTCNotSupportCopyButton: 'ワンキーでコピー',
  Copied: 'コピー済み',
  search: '検索',
  searchContent: '検索内容',
  noResult: '結果が見つかりません',
  searchResult: '検索結果',
  relatedResult: 'おすすめ',
  scaleUp: '拡大',
  scaleDown: '縮小',
  viewIn3D: '3D で表示',
  unableJoinMeeting: '会議に参加できません',
  invalidMeetingId: '無効な会議番号です',
  unableAccessMediaDevice: 'ブラウザはお客様のカメラ/マイクロフォンにアクセスできません。ブラウザのメディア権限を開くに設定しページを再起動してください。',
  connectingMeeting: 'まもなく会議を開催します',
  meetingNotStartedYet: '会議が作成されていないので加入できません',
  joinedMeeting: '会議に加入しています',
  joiningMeeting: 'まもなく会議に加入します',
  repeatJoinWarning: '再加入した場合、元々接続していたページは接続を中断します',
  meetingIsOver: '会議はすでに終了しました',
  startAnotherMeeting: 'ブラウザで別の会議を開いてください',
  closeMeeting: '会議を終了する',
  joinMeeting: '会議に加入する',
  leaveMeeting: '会議を離れる',
  remainTime: '残り時間',
  meetingIsFull: '現在会議参加人数が上限に達しました',
  connectionFail: '接続に失敗しました',
  unableConnectMeeting: '会議に接続できません',
  joinMeetingFail: '会議の加入に失敗しました',
  aboutEndMeeting: 'まもなくこの会議は終了します',
  aboutLeaveMeeting: 'まもなくこの会議を離れます',
  endedMeeting: '今回の会議はすでに終了しました',
  meetingRedirect: 'LiveTourに戻ります',
  leftMeeting: 'すでに今回の会議を離れました',
  waitMeeting: '主催者が一時的にオフラインです。主催者がオンラインになり次第会議を続けます。5分間待ってオンラインにならない場合、会議を終了します。',
  disconnectMeeting: '切断されています。 5分以内に再接続し、ページを更新して会議に戻ってください。',
  copyLink: 'リンクのコピー',
  copySuccess: 'コピーに成功しました',
  confirm: '決定',
  cancel: 'キャンセル',
  product: '製品',
  pilot: 'ガイド',
  pilotStop: 'ガイドの終了',
  pilotTours: 'ガイドコース',
  pilotPopularTours: '人気のガイドコース',
  pilotInfluencerList: 'ガイドスタッフリスト',
  pilotTourBy: '{influencer}の全てのガイドコース',
  PilotDescription: 'コンテンツの紹介',
  PilotDetailedInformation: '主な展示内容',
  pilotSwitchTourNotice: '現在「{pilot1}」を再生中です。「{pilot2}」に切り替えますか。',
  pilotSameTourNotice: '現在「{pilot1}」を再生中です。最初から始めますか。',
  pilotPlayerPopupButtonYes: '決定',
  pilotRecorderStart: 'ここをクリックすると録画が始まります',
  pilotRecorderStop: 'ここをクリックすると録画を終了します',
  pilotRecorderUploading: 'アップロード中',
  pilotRecorderUploadFailed: 'アップロードに失敗しました',
  pilotRecorderPopupTitleNotice: '説明',
  pilotRecorderPopupTitleComplete: '録画に成功しました',
  pilotRecorderPopupTitleError: 'エラー',
  pilotRecorderPopupTextNotice: '・録画時間制限は10分間です。<br>・録画する前にシステムがマイクの使用許可にアクセスできるよう許可してください。',
  pilotRecorderPopupTextComplete: 'ガイド章節の録画が完成しました。VR Editorに戻り視聴と編集を行ってください。',
  pilotRecorderPopupTextRelogin: '再ログインしてください',
  pilotRecorderPopupTextError: 'お客様のブラウザのマイクへのアクセス権限を検査してください',
  pilotRecorderPopupButtonOK: 'OK',
  pilotRecorderRemainTimeWarning: '10分間の録画時間は間もなく終了します。録画をできるだけ早く終えてください。',
  pilotTooltipTitle: 'リマインダー、ここをクリックしてガイド付きルートをさらに表示できます。',
  pilotTooltipConfirm: 'なるほど！ はじめましょう',
  pilotTooltipCancel: 'ツアーをスキップ',
  selectPilot: 'パイロットを選択',
  pilotInfluencer: 'パイロット インフルエンサー',
  pilotChaptersTitle: 'ルートチャプター (聞くことを選択)',
  pilotReadMoreBtnLabel: 'すべてのコンテンツを表示',
  pilotSelfBrowsingModeMessageTitle: '自己閲覧モードに入る',
  pilotSelfBrowsingModeMessageContent: 'オン ボタンをクリックすると、いつでもツアー モードに戻ることができます。',
  pilotReplay: 'リプレイ',
  pilotPrevious: '前',
  pilotNext: '次へ',
  pilotPause: '一時停止',
  pilotPlay: 'プレイ',
  pilotTurnOnSelfBrowsingMode: 'ツアーモードをオフにする',
  pilotTurnOffSelfBrowsingMode: 'ツアーモードをオンにする',
  conferenceDisconnect: '接続状態が不安定です。ネットワーク接続を検査してください。',
  conferenceMute: 'ミュート',
  conferenceUnmute: 'ミュートの取り消し',
  conferenceStopVideo: 'ビデオの取り消し',
  conferenceVideo: 'ビデオ',
  conferenceShare: '共用',
  conferenceChat: 'チャット',
  conferenceParticipant: '参加者',
  conferenceAudience: '参加者',
  conferenceMore: 'オプション',
  conferenceCopyLink: '会議リンクのコピー',
  conferenceCameraAndMicrophone: 'ビデオとマイク',
  conferenceHost: '主催者',
  conferencePresenter: 'プレゼンター',
  conferenceExpel: '追放する',
  conferenceChangeRole: 'キャラクターを変更する',
  conferenceTypeMessage: 'ここにお客様の情報を入力してください',
  conferenceEveryone: '所有者',
  conferenceLoginError: 'チャンネルログイン時にエラーが出ました。もう一度お試しください。',
  conferenceJoinError: 'チャンネル進入時にエラーが出ました。もう一度お試しください。',
  conferenceLeaveError: 'チャンネルを離れる際にエラーが出ました。もう一度お試しください。',
  conferenceGetMemberCountError: 'チャンネルメンバー数を得る際にエラーが出ました。もう一度お試しください。',
  conferenceSendMessageError: 'メッセージ発信時にエラーが出ました。もう一度お試しください。',
  conferenceSendInfoError: '情報発表時にエラーが出ました。もう一度お試しください。',
  conferenceGetMemberError: 'チャンネルメンバーを得る際にエラーが出ました。もう一度お試しください。',
  conferenceChangeRoleError: 'キャラクター設定時にエラーが出ました。もう一度お試しください。',
  conferencePublishError: '映像発表時にエラーが出ました。もう一度お試しください。',
  conferenceCancelPublishError: '映像発表取り消し時にエラーが出ました。もう一度お試しください。',
  conferenceGetMemberInfoError: 'メンバー情報を得る際にエラーが出ました。もう一度お試しください。',
  conferenceSetMediatError: '映像調整時にエラーが出ました。もう一度お試しください。',
  conferenceToLeave: '会議を離れますか',
  conferenceToExpel: '%{name}を追放しますか',
  conferenceChangeRoleFail: 'キャラクターの変更に失敗しました',
  conferenceGetChangeRole: '主催者があなたを%{role}に設定します',
  conferenceGetCameraClosed: '主催者があなたのオーディオ画面を閉じます',
  conferenceGetUnmuted: '主催者があなたのミュートを取り消します',
  conferenceGetMuted: '主催者があなたをミュートします',
  conferenceCopyLinkSuccess: 'リンクはすでにコピーしました',
  conferenceGetExpeled: 'あなたは会議を追い出されました',
  conferenceBrowserNotSupported: 'お客様のブラウザはサポートしていません。最新バージョンのChrome、Safari又はEdgeに変更してください。',
  conferenceNotStart: '会議はまだ始まっていません',
  conferenceEnd: '会議はすでに終了しました',
  conferenceTimeup: '会議の時間になりました',
  conferenceMicrophone: 'マイクロフォン',
  conferenceSoundLevel: '音声レベル',
  conferenceVolume: '音量',
  conferenceCamera: 'ビデオカメラ',
  conferenceDetectAudioFail: 'マイクを検知できません',
  conferenceDetectVideoFail: 'カメラを検知できません',
  conferenceShareNotAvailable: 'お客様のブラウザはこの機能をサポートしていません。コンテンツを享有するには最新バージョンのChrome、Edge或Firefoxをご使用ください。',
  conferenceScreenNotAvailable: '他のプレゼンターがディスプレイをシェアしています',
  uploadImage: '画像をアップロード',
  booking: {
    calendar: 'カレンダー',
    reserve: '予約',
    dateSelectTitle: 'あなたの適切な時間帯を選択',
    backToSelect: '別の時間を選択',
    requiredField: '入力必須',
    timeRange: '時間帯',
    fieldMessage: 'メッセージ',
    confirm: '予約の確認',
    pleaseWait: 'お待ち下さい…',
    submitError: 'リスエスト送信時にエラーが発生しました',
    reserveSuccess: '予約に成功しました',
    thanksUser: 'ありがとうございます,',
    confirmingEmail: 'お客様はまもなく会議の詳細な情報確認通知を受け取ります。',
    emailEmptyHint: 'メールが空です。'
  },
  favorites: {
    title: 'お気に入り',
    add: 'お気に入りに加える',
    remove: 'お気に入りから削除する',
    category: {
      marker: '製品',
      panorama: 'ブース',
      company: '会社',
      card: '名刺'
    },
    table: {
      image: {
        company: 'Logo',
        marker: '製品画像',
        card: '個人写真'
      },
      name: {
        company: '会社名',
        marker: '製品名',
        card: '氏名'
      },
      description: {
        company: '会社紹介',
        marker: '製品紹介'
      },
      type: 'タイプ',
      // price: '',
      note: '備考',
      company: '会社',
      occupation: '職位',
      listEmpty: 'まだコンテンツがありません'
    },
    note: {
      empty: '備考を入力してください…（最多{n}文字）',
      saved: '保存しました'
    },
    pdf: {
      export: 'PDFでエクスポート',
      exporting: 'エクスポート中…',
      note: '備考：',
      pager: '{page}ページ目、全{total}ページ'
    }
  },
  introAssets: {
    enter: '入る'
  },
  whiteList: {
    login: 'サインインして探索しましょう！',
    error: '*アカウントまたはパスワードが無効です！ もう一度やり直してください。',
    warnTitle: '認証に失敗しました',
    warnContent: 'お客様が入力したアカウントは許可リストにありません。もう一度入力するか管理者に連絡してください。'
  },
  instantMessaging: {
    quickQA: 'クイックQ&A',
    mediaMessage: '1件のファイルをシェアしました',
    locationMessage: '位置情報をシェアしました',
    startConversation: 'この展示エリアの主催者と会話を始めましょう。'
  },
  noSearchResult: 'データがありません。検索条件を変更し、再検索してください。',
  tourring: {
    host: 'ホスト',
    noAnswer: 'お客様の連絡者は現在電話に出られません。',
    noPushId: 'お客様の連絡者は現在オンラインではありません。',
    busy: 'お客様の連絡者は案内中です。',
    response: '当社のカレンダー機能を利用してのご予約ありがとうございます。',
    goToReserve: 'カレンダーの予約に行く',
    dialing: 'ダイヤル中',
    dialingHint: 'つながり次第、新しいタブにご案内します',
    handupPhoneHint: 'お客様の電話はつながっていません',
    handupPhoneHint2: '電話を切りますか'
  },
  productUnavailable: 'このアイテムは使用できなくなりました'
}

export default ja
